import { ImageProps } from "./image-props";

export const AssigneeBlake24Image = (props: ImageProps) => {
    return (
        <img
            height={24}
            width={24}
            alt={props.alt}
            src="https://wac-cdn.atlassian.com/dam/jcr:0536a3ba-ed41-436e-af7f-0f621e69c2d7/illustrations-meeples-Simplified%20Meeples-Aliza.svg"
            data-testid={props["data-testid"]}
            className={props.className}
        />
    );
};
